import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { AbinResultDto } from 'src/app/inge-api/abinclient/models';
import { Store, select } from '@ngrx/store';
import { InGeApiState } from 'src/app/store/state-model/inge-api.model';

@Component({
    selector: 'app-foryngring-bordig-mark-sammanvagning',
    templateUrl: './foryngring-bordig-mark-sammanvagning.component.html',
    styleUrls: ['./foryngring-bordig-mark-sammanvagning.component.scss']
})
export class ForyngringBordigMarkSammanvagningComponent implements OnInit {
    inventeringar$: Observable<AbinResultDto>;
    inventeringarLoading$: Observable<boolean>;
    inventeringarError$: Observable<boolean>;
    private subs: Subscription[];
    constructor(private store: Store<InGeApiState>) {
        this.inventeringar$ = this.store.pipe(
            select((x) => {
                if (x && x.abin.inventeringar && x.abin.inventeringar.length > 0) {
                    return x.abin.inventeringar[0];
                }
            })
        );
        this.inventeringarLoading$ = store.pipe(select((x) => x.abin.loadingInventeringar));
        this.inventeringarError$ = store.pipe(select((x) => x.abin.inventeringarError));
    }

    ngOnInit(): void {}
}
